import { useState } from 'react';
import { Box } from '@mui/material';
import MatrixSelector from './MatrixSelector';
import MatrixFilter from './MatrixFilter';
import ProductSwMatrix from './ProductSwMatrix';
import FeatureSwVersionMatrix from './FeatureSwVersionMatrix';
import ProjectFeatureMatrix from './ProjectFeatureMatrix';

// FEAT-002 매트릭스 루트 컨테이너 + FEAT-003 편집 콜백 전달.
// 결정 1 (신규 페이지) + 결정 5 (variant 전환 시 검색/필터 유지) + 결정 10 (MatrixPage 가 buffer state, 본 컴포넌트는 콜백 prop 전달).
//
// Props:
//   products / features / softwares : 데이터 (MatrixPage 가 buffer 상태로 보유)
//   onComponentEdit  : (feature, componentIndex) => void  (관점 2 Badge 클릭)
//   onAddComponent   : (feature) => void                  (행 메뉴 "구성 SW 추가")
//   onDeleteFeature  : (feature) => void                  (행 메뉴 "삭제")
export default function MatrixView({
  products,
  features,
  softwares,
  projects = [],
  initialVariant = 'product-sw',
  initialProject = '',
  onComponentEdit,
  onAddComponent,
  onDeleteFeature,
}) {
  const [variant, setVariant] = useState(initialVariant);
  const [search, setSearch] = useState('');
  const [selectedStatuses, setSelectedStatuses] = useState([]);

  const handleToggleStatus = (s) => {
    setSelectedStatuses((prev) =>
      prev.includes(s) ? prev.filter((x) => x !== s) : [...prev, s],
    );
  };

  return (
    <Box>
      <MatrixSelector value={variant} onChange={setVariant} />
      <MatrixFilter
        variant={variant}
        search={search}
        onSearchChange={setSearch}
        selectedStatuses={selectedStatuses}
        onToggleStatus={handleToggleStatus}
      />
      {variant === 'product-sw' && (
        <ProductSwMatrix products={products} softwares={softwares} search={search} />
      )}
      {variant === 'feature-sw-version' && (
        <FeatureSwVersionMatrix
          features={features}
          softwares={softwares}
          search={search}
          selectedStatuses={selectedStatuses}
          onComponentEdit={onComponentEdit}
          onAddComponent={onAddComponent}
          onDeleteFeature={onDeleteFeature}
        />
      )}
      {variant === 'project-feature' && (
        <ProjectFeatureMatrix
          projects={projects}
          features={features}
          products={products}
          search={search}
          selectedStatuses={selectedStatuses}
          initialProject={initialProject}
        />
      )}
    </Box>
  );
}
